import _ from 'lodash';
import React from 'react';
import styled from 'styled-components';
import { Border, Box, Flex, Padding, Stack, Text } from '../../components';
import { ExpandableQuestionView, questionsAndAnswers } from './shared';

const BackgroundWrapper = styled.div`
  display: flex;
  background-color: #f3f6f6;
`;

export const FrequentlyAskedQuestionsDesktop = () => {
  return (
    <BackgroundWrapper>
      <Flex flex={2}>
        <Padding size={[7]}>
          <Padding size={[0, 0, 7, 0]}>
            <Text textType="heading3" align="left">
              Frequently Asked Questions
            </Text>
          </Padding>
          <Border borderSize={[1, 0, 0, 0]} borderRole="grey3">
            {_.flow((questionsAndAnswers) =>
              _.map(questionsAndAnswers, (singleValue, index) => {
                return (
                  <ExpandableQuestionView
                    questionAndAnswer={singleValue}
                    key={index}
                  />
                );
              })
            )(questionsAndAnswers)}
          </Border>
        </Padding>
      </Flex>
      <Flex flex={1}>
        <Padding size={[7, 0, 0, 0]}>
          <Box
            ratio={1.5}
            backgroundImage="images/frequently-asked-questions-picture.jpg"
          />
        </Padding>
      </Flex>
    </BackgroundWrapper>
  );
};
